import Vue from 'vue';

Vue.component('folder-list-content-vue', {
  data() {
    return {
      showBookmarkOpt: false
    };
  },
  methods: {
    showBookmark(index) {
      this.showBookmarkOpt = !this.showBookmarkOpt; // Toggle the showBookmarkOpt state on each click
      const bookmarkOptionsDiv = document.querySelector('.bookmark-options-div');
      bookmarkOptionsDiv.classList.toggle('change');
      const baseTop = 200;
      const inc = 51;
      const newTop = baseTop + (index) * inc;
      bookmarkOptionsDiv.style.top = newTop + 'px';
    },
    checkedItem(index) {
      const container = document.getElementsByClassName('folder-list-content__items__item--checkbox')[index];
      const listItem = document.getElementsByClassName('folder-list-content__items__item')[index];
      const checkbox = container.querySelector('input[type="checkbox"]');
      checkbox.checked ? listItem.classList.add('folder-list-content__items__item--active') : listItem.classList.remove('folder-list-content__items__item--active');
    },
    selectAllCheckbox() {
      const checkboxItem = document.querySelector('#checkbox-1');
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      const listItem = document.querySelectorAll('.folder-list-content__items__item');

      checkboxItem.addEventListener('click', () => {
        checkboxItem.checked = !checkboxItem.checked
        checkboxes.forEach(checkbox => {
          checkbox.checked = !checkbox.checked;
          listItem.forEach(item => {
            item.classList.toggle('folder-list-content__items__item--active');
          });
        });
      });
    },
  }
});
